import axios from 'axios';
import Cookie from 'cookies-js';
import toastr from 'toastr';
import config from '../../config/index';
import routes from '../../constants/routes';
import {
  WITHDRAW_TARGET_SAVING_SUCCESS,
  WITHDRAW_TARGET_SAVING_ERROR,
  WITHDRAW_TARGET_SAVING_LOADING,
  WITHDRAW_TARGET_SAVING_ERROR_DELETE
} from '../types';

const withdrawTargetSavingSuccess = withdrawal => ({
  type: WITHDRAW_TARGET_SAVING_SUCCESS,
  withdrawal
});

const withdrawTargetSavingLoading = () => ({
  type: WITHDRAW_TARGET_SAVING_LOADING
});

const withdrawTargetSavingError = error => ({
  type: WITHDRAW_TARGET_SAVING_ERROR,
  error
});

export const deleteWithdrawTargetSavingError = () => ({
  type: WITHDRAW_TARGET_SAVING_ERROR_DELETE
});

const withdrawTargetSaving = withdrawDetails => (dispatch) => {
  dispatch(withdrawTargetSavingLoading());
  const token = Cookie.get('jwtToken');
  return axios.post(
    `${config.apiUrl}${routes.WITHDRAWTARGETSAVINGS}`, withdrawDetails, {
      headers: { Authorization: `Bearer ${token}` }
    }
  ).then((response) => {
    const { data } = response;
    if (data.isSuccessful) {
      dispatch(withdrawTargetSavingSuccess(data));
      toastr.success('Success!');
    } else {
      dispatch(withdrawTargetSavingError(data.responseMessage));
    }
  }).catch((error) => {
    const { data } = error.response;
    dispatch(withdrawTargetSavingLoading());
    dispatch(withdrawTargetSavingError(data.responseMessage));
    throw error;
  });
};

export default withdrawTargetSaving;
